<script>
// ************************************************************
// Definisce un grafico a barre orizzontali.
// Questa libreria non ammette che si aggiunga il tag template
// all'interno del componente ( vedi documentazione per info )
// ************************************************************
import { HorizontalBar, mixins } from 'vue-chartjs'

export default {
  name: 'BarChart',
  extends: HorizontalBar,
  mixins : [ mixins.reactiveProp ],
  data () {

    // Per far figurare la lunghezza dell'asse x non coincidente
    // sempre con il massimo valore del credito, prendiamo il massimo
    // valore dei dati visualizzati ( tra credito tot e art51c3 )
    // e lo impostiamo ad un 20% in più.
    let max = Math.max( this.chartData.datasets[0].data );
    max = max + ( Math.round( max * 0.2 ) );

    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        // Nessuna legenda.
        legend: {
          display: false
        },
        // Aggiungiamo padding per far comprimente un poco il
        // grafico sotto e sopra di modo tale che appaia più
        // gradevole alla vista.
        layout: {
          padding: {
              left: 0,
              right: 0,
              top: 30,
              bottom: 130
          }
        },
        scales: {
          // Per l'asse delle X:
          // - beginAtZero: La scala deve sempre partire da zero.
          // - suggestedMax: Il massimo valore mostrato deve essere quello calcolato sopra.
          // - maxTicksLimit: Visualizziamo un massimo di 5 etichette sull'asse.
          // - minRotation: Visualizziamo le etichette ruotate di 30 gradi per evitare
          //   che vengano mostrate tagliate.
          // - gridLines -> display: Nascondiamo la griglia in x per rendere il grafico più pulito.
          xAxes: [{
            ticks: {
              beginAtZero: true,
              suggestedMax: max,
              maxTicksLimit: 5,
              minRotation: 30
            },
            gridLines	: {
              display: false
            }
          }]
        }
      }
    }
  },
  mounted : function  () {
    this.renderChart( this.chartData, this.options )
  }
}
</script>

<style>
</style>
